import { render, staticRenderFns } from "./PayuView.vue?vue&type=template&id=04dcd3c1&lang=pug"
import script from "./PayuView.vue?vue&type=script&lang=js"
export * from "./PayuView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports